import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import GatsbyImage from 'gatsby-image'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { getThemeColor } from '@/utils/themes'
import { mq, rem } from '@/utils/helpers'
import { mobile } from '@/utils/media'
import Typography from '@/components/common/Typography'
import Number from './Number'

const Template = props => {
  const { theme, number, heading, body, image, ...others } = props
  const even = number % 2 === 0
  return (
    <Root theme={theme} {...others} even={even}>
      <Left even={even}>
        <Heading>
          <Heading_Number color="primary">{number}</Heading_Number>
          <Heading_Text theme={theme} variant="d5" component="div">{heading}</Heading_Text>
        </Heading>
        <Body variant="body3">{body}</Body>
      </Left>
      <Right even={even}>
        <Image fluid={image}/>
      </Right>
    </Root>
  )
}

export default ThemeConsumer(Template)

const Root = styled.div`
  display: flex;
  ${props => {
    if (props.even) {
      return css`
        flex-direction: row-reverse;
      `
    }
  }}

  @media ${mq.and(mobile)} {
    display: block;
  }
`

const Left = styled.div`
  ${props => {
    if (!props.even) {
      return css`
        margin-right: ${rem(24)};
      `
    }
  }}
  width: ${rem(392)};
  flex-shrink: 0;

  @media ${mq.and(mobile)} {
    width: 100%;
    margin-right: 0;
  }
`

const Heading = styled.h3`
  display: flex;
  align-items: center;
`

const Heading_Number = styled(Number)`
  flex-shrink: 0;
  margin-right: ${rem(16)};
`

const Heading_Text = styled(Typography)`
  strong {
    color: ${props => getThemeColor('primary', props.theme)}
  }
`

const Body = styled(Typography)`
  margin-top: ${rem(24)};
`

const Right = styled.div`
  flex-grow: 1;
  ${props => {
    if (props.even) {
      return css`
        margin-right: ${rem(24)};
      `
    }
  }}

  @media ${mq.and(mobile)} {
    margin-right: 0;
    margin-top: ${rem(24)};
  }
`

const Image = styled(GatsbyImage)``
